import type { AsyncBelongsTo } from '@ember-data/model';
import Model, { attr, hasMany } from '@ember-data/model';

import type AnnouncementTemplateModel from './announcement-template';

export type AnnouncementResponseCategory = 'safe' | 'need_help' | 'other';

export type AnnouncementResponseOption = {
  label: string;
  category: AnnouncementResponseCategory;
};

export default class AnnouncementAttachmentModel extends Model {
  // Relationships
  @hasMany('announcement-template', { async: true, inverse: 'announcementAttachments' })
  declare announcementTemplate: AsyncBelongsTo<AnnouncementTemplateModel>;

  // Attributes
  @attr('string') declare rasterImageName: string;
  @attr('string') declare envoyImageUrl: string;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'announcement-attachment': AnnouncementAttachmentModel;
  }
}
